import { useEffect } from "react";
// react-router components
import { Routes, Route, useLocation } from "react-router-dom";
import ExternalRedirect from "./examples/Redirect";
// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import theme from "assets/theme";

import ProductDetail from "pages/ProductDetail";
import Products from "pages/Products";
import ChangeLog from "pages/Changelog";
import BatchLink from "layouts/pages/Batch Link";
import routes from "routes";

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  document.title = "Waltek Company Ltd.";

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {getRoutes(routes)}

        <Route path="*" element={<ExternalRedirect />} />
        <Route
          exact
          key="Checklist Index"
          path="/Opening-Check-List/:id/:item"
          element={<ProductDetail />}
        />
        <Route exact path="/Opening-Check-List/:id" element={<Products />} />
        <Route exact path="/ChangeLog" element={<ChangeLog />} />
        <Route exact key="Batch Link" path="/BatchLink/" element={<BatchLink />} />
      </Routes>
    </ThemeProvider>
  );
}
